import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AutomotiveAftermarketProfileListService } from './automotive-aftermarket-profile-list.service';
import {
  AutomotiveAftermarketProfileListInitialState,
  AutomotiveAftermarketProfileListLoad,
} from './automotive-aftermarket-profile-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { PlannerProfile } from '../../../../models';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type AutomotiveAftermarketProfileListStateModel = ListServerPaginationStateModel<PlannerProfile>;

const initialState: AutomotiveAftermarketProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<AutomotiveAftermarketProfileListStateModel>({
  name: 'automotiveAftermarketProfileList',
  defaults: initialState,
})
@Injectable()
export class AutomotiveAftermarketProfileListState {
  constructor(
    private materialPlannerProfileListService: AutomotiveAftermarketProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: AutomotiveAftermarketProfileListStateModel): AutomotiveAftermarketProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: AutomotiveAftermarketProfileListStateModel): PlannerProfile[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: AutomotiveAftermarketProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(AutomotiveAftermarketProfileListLoad)
  getTransportList(
    ctx: StateContext<AutomotiveAftermarketProfileListStateModel>,
    { payload }: AutomotiveAftermarketProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.materialPlannerProfileListService.getAutomotiveAftermarketProfileList(payload).pipe(
      map((materialPlannerProfileList: AutomotiveAftermarketProfileListStateModel) => {
        ctx.patchState({ ...materialPlannerProfileList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AutomotiveAftermarketProfileListInitialState)
  setInitialState(ctx: StateContext<AutomotiveAftermarketProfileListInitialState>): void {
    ctx.setState(initialState);
  }
}
